export enum View {
	tasks = 'tasks',
	routes = 'routes'
}
